import {
  SocketAsFetch as LeagueSocketAsFetch,
  WebsocketMessage,
  FetchOptions,
} from '@leagueplatform/socket-as-fetch';
import { combineErrorContexts } from '@leagueplatform/observability';
import { SENTRY_CONSTANTS } from 'common/constants';

export const socketAsFetch = (
  message: WebsocketMessage,
  options?: FetchOptions,
) =>
  LeagueSocketAsFetch.fetch(message, {
    errorContext: combineErrorContexts([
      {
        errorName: `Telus Socket Fetch Response Error - ${message.message_type}`,
        ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      },
      options?.errorContext || {},
    ]),
  });
